import React from 'react';
import { PageHeader } from '../components/ui/PageHeader';
import { SectionHeading } from '../components/ui/SectionHeading';
import { Card, CardContent } from '../components/ui/Card';
import { AlertTriangle, Clock, Mail, CheckCircle2 } from 'lucide-react';
import { CFA_INFO } from '../data/constants';
export function Reclamations() {
  return <div className="flex flex-col w-full" data-id="element-2152">
      <PageHeader title="Gestion des Réclamations" subtitle="Votre satisfaction est notre priorité. Nous sommes à votre écoute pour traiter toute insatisfaction." data-id="element-2153" />

      <div className="py-16 md:py-24 bg-white relative overflow-hidden" data-id="element-2154">
        <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-brand-orange rounded-full blur-[100px] opacity-10 pointer-events-none" data-id="element-2155" />
        <div className="container max-w-5xl mx-auto relative z-10" data-id="element-2156">
          <section className="text-center mb-20" data-id="element-2157">
            <p className="text-xl md:text-2xl text-muted-foreground leading-relaxed max-w-3xl mx-auto font-medium" data-id="element-2158">
              Dans le cadre de notre démarche d'amélioration continue, Zillenium
              Alternance met à disposition de l'ensemble de ses parties
              prenantes (apprentis, entreprises, financeurs, partenaires) une
              procédure de gestion des réclamations claire et transparente.
            </p>
          </section>

          <div className="grid md:grid-cols-2 gap-10 mb-20" data-id="element-2159">
            <Card className="border-none shadow-xl bg-white hover:-translate-y-2 transition-transform duration-300 group" data-id="element-2160">
              <div className="h-2 w-full bg-primary" data-id="element-2161" />
              <CardContent className="p-8 md:p-10" data-id="element-2162">
                <h3 className="text-2xl font-extrabold font-heading text-primary-dark mb-8 flex items-center gap-4" data-id="element-2163">
                  <div className="w-12 h-12 rounded-xl bg-lavande flex items-center justify-center group-hover:scale-110 transition-transform" data-id="element-2164">
                    <AlertTriangle className="w-6 h-6 text-primary animate-soft-pulse" data-id="element-2165" />
                  </div>
                  Motifs de réclamation possibles
                </h3>
                <ul className="space-y-5" data-id="element-2166">
                  <li className="flex items-start gap-4" data-id="element-2167">
                    <div className="w-2 h-2 rounded-full bg-brand-orange mt-2.5 shrink-0" data-id="element-2168"></div>
                    <span className="text-muted-foreground leading-relaxed" data-id="element-2169">
                      <strong className="text-primary-dark font-bold" data-id="element-2170">
                        Pédagogique :
                      </strong>{' '}
                      contenu de la formation, méthodes, évaluation.
                    </span>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-2171">
                    <div className="w-2 h-2 rounded-full bg-brand-orange mt-2.5 shrink-0" data-id="element-2172"></div>
                    <span className="text-muted-foreground leading-relaxed" data-id="element-2173">
                      <strong className="text-primary-dark font-bold" data-id="element-2174">
                        Administratif :
                      </strong>{' '}
                      inscription, contrat, facturation.
                    </span>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-2175">
                    <div className="w-2 h-2 rounded-full bg-brand-orange mt-2.5 shrink-0" data-id="element-2176"></div>
                    <span className="text-muted-foreground leading-relaxed" data-id="element-2177">
                      <strong className="text-primary-dark font-bold" data-id="element-2178">
                        Organisationnel :
                      </strong>{' '}
                      planning, locaux, matériel.
                    </span>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-2179">
                    <div className="w-2 h-2 rounded-full bg-brand-orange mt-2.5 shrink-0" data-id="element-2180"></div>
                    <span className="text-muted-foreground leading-relaxed" data-id="element-2181">
                      <strong className="text-primary-dark font-bold" data-id="element-2182">
                        Relation entreprise :
                      </strong>{' '}
                      suivi en entreprise, missions.
                    </span>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-2183">
                    <div className="w-2 h-2 rounded-full bg-brand-orange mt-2.5 shrink-0" data-id="element-2184"></div>
                    <span className="text-muted-foreground leading-relaxed" data-id="element-2185">
                      <strong className="text-primary-dark font-bold" data-id="element-2186">
                        Accessibilité :
                      </strong>{' '}
                      accueil PSH, aménagements.
                    </span>
                  </li>
                </ul>
              </CardContent>
            </Card>

            <div className="space-y-10" data-id="element-2187">
              <Card className="bg-primary-dark text-white border-none shadow-xl hover:-translate-y-2 transition-transform duration-300 group" data-id="element-2188">
                <div className="h-2 w-full bg-primary-accent" data-id="element-2189" />
                <CardContent className="p-8 md:p-10" data-id="element-2190">
                  <h3 className="text-2xl font-extrabold font-heading mb-6 flex items-center gap-4" data-id="element-2191">
                    <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center group-hover:scale-110 transition-transform" data-id="element-2192">
                      <Mail className="w-6 h-6 text-lavande animate-soft-float" data-id="element-2193" />
                    </div>
                    Comment nous contacter ?
                  </h3>
                  <p className="text-lavande mb-6 leading-relaxed text-lg" data-id="element-2194">
                    Toute réclamation doit être formulée par écrit et envoyée à
                    l'adresse email suivante :
                  </p>
                  <a href={`mailto:${CFA_INFO.email}`} className="text-xl font-bold text-brand-orange hover:text-white transition-colors underline underline-offset-4" data-id="element-2195">
                    {CFA_INFO.email}
                  </a>
                  <p className="text-sm text-lavande/70 mt-6 leading-relaxed" data-id="element-2196">
                    Merci de préciser "Réclamation" dans l'objet de votre email
                    et de détailler au maximum le motif de votre insatisfaction.
                  </p>
                </CardContent>
              </Card>

              <Card className="border-none shadow-lg bg-white hover:-translate-y-1 transition-transform duration-300 group" data-id="element-2197">
                <CardContent className="p-8" data-id="element-2198">
                  <h3 className="font-extrabold font-heading text-xl text-primary-dark mb-6 flex items-center gap-4" data-id="element-2199">
                    <div className="w-10 h-10 rounded-lg bg-lavande flex items-center justify-center group-hover:scale-110 transition-transform" data-id="element-2200">
                      <Clock className="w-5 h-5 text-brand-orange animate-soft-pulse" data-id="element-2201" />
                    </div>
                    Délais de traitement
                  </h3>
                  <div className="space-y-4 text-base" data-id="element-2202">
                    <div className="flex justify-between items-center pb-4 border-b border-slate-100" data-id="element-2203">
                      <span className="text-muted-foreground font-medium" data-id="element-2204">
                        Accusé de réception
                      </span>
                      <span className="font-bold text-primary-dark" data-id="element-2205">
                        Sous 48h ouvrées
                      </span>
                    </div>
                    <div className="flex justify-between items-center" data-id="element-2206">
                      <span className="text-muted-foreground font-medium" data-id="element-2207">
                        Réponse et plan d'action
                      </span>
                      <span className="font-bold text-primary-dark" data-id="element-2208">
                        Sous 10 jours ouvrés
                      </span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>

          <div className="text-center bg-muted p-10 md:p-12 rounded-3xl border-none shadow-sm" data-id="element-2209">
            <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-6 shadow-sm" data-id="element-2210">
              <CheckCircle2 className="w-10 h-10 text-primary animate-soft-bounce" data-id="element-2211" />
            </div>
            <p className="text-xl font-medium text-primary-dark leading-relaxed max-w-2xl mx-auto" data-id="element-2212">
              Chaque réclamation est analysée par notre direction et fait
              l'objet d'une action corrective dans le cadre de notre démarche
              d'amélioration continue.
            </p>
          </div>
        </div>
      </div>
    </div>;
}